import { marked } from 'marked';

/**
 * Converts markdown to HTML
 * Returns the original string if it's already HTML or if conversion fails
 */
export function markdownToHtml(markdown: string): string {
  if (!markdown || typeof markdown !== 'string') {
    return markdown || '';
  }

  // Check if content is already HTML (has HTML tags)
  const hasHtmlTags = /<\/?(h[1-6]|p|div|span|strong|em|ul|ol|li|blockquote|code|pre|a|img|br|hr)\b[^>]*>/i.test(markdown.trim());
  
  if (hasHtmlTags) {
    // Already HTML, return as-is
    return markdown;
  }

  // Check if content looks like markdown (has markdown syntax)
  const hasMarkdownSyntax = /^#{1,6}\s+|^\*\*|^\* |^-\s+|^`|^```|^>\s+/m.test(markdown);
  
  if (!hasMarkdownSyntax) {
    // Doesn't look like markdown, return as-is (might be plain text)
    return markdown;
  }

  try {
    // Configure marked options
    marked.setOptions({
      breaks: true, // Convert line breaks to <br>
      gfm: true, // GitHub Flavored Markdown
    });

    // Convert markdown to HTML
    const html = marked.parse(markdown);
    const result = typeof html === 'string' ? html : markdown;
    
    // Log if result is empty but input wasn't
    if (!result && markdown) {
      console.warn('Markdown conversion returned empty string', { markdownLength: markdown.length, markdownPreview: markdown.substring(0, 100) });
      return markdown; // Return original if conversion failed
    }
    
    return result;
  } catch (error) {
    console.error('Error converting markdown to HTML:', error);
    return markdown; // Return original on error
  }
}
